// import {
//   deselectLeafMultipleSelectionOption,
//   deselectMultipleSelectionOption,
//   saveQuantity,
//   selectMultipleSelectionOption,
// } from '../bom/actions';

import {
  priceRecalculationFailed,
  resetPriceRecalculationResponse,
  savePriceRecalculationResponse,
  startPriceRecalculation,
} from './actions';

import { NumericValueOfNotAvailable } from '../utils/constants';
import { PricingStatus } from './constants';
import { createReducer } from '@reduxjs/toolkit';

const initialPriceRecalculationResponse = {
  status: PricingStatus.Idle,
  discount: NumericValueOfNotAvailable,
  totalPrice: NumericValueOfNotAvailable,
  unitPrice: NumericValueOfNotAvailable,
};

const pendingPriceRecalculationResponse = {
  status: PricingStatus.Loading,
  discount: NumericValueOfNotAvailable,
  totalPrice: NumericValueOfNotAvailable,
  unitPrice: NumericValueOfNotAvailable,
};

const failedPriceRecalculationResponse = {
  status: PricingStatus.Failed,
  discount: NumericValueOfNotAvailable,
  totalPrice: NumericValueOfNotAvailable,
  unitPrice: NumericValueOfNotAvailable,
};

export const priceRecalculationResponse = createReducer(initialPriceRecalculationResponse, (builder) => {
  builder
    .addCase(startPriceRecalculation, (state, action) => pendingPriceRecalculationResponse)

    .addCase(resetPriceRecalculationResponse, (state, action) => initialPriceRecalculationResponse)

    .addCase(savePriceRecalculationResponse, (state, action) => action.payload)

    .addCase(priceRecalculationFailed, (state, action) => failedPriceRecalculationResponse);

  // Note: comment out these statements to fix the issue of displaying 'NA' in the Order Summary section
  // [deselectLeafMultipleSelectionOption],(state, action) => initialPriceRecalculationResponse,
  // [deselectMultipleSelectionOption],(state, action) => initialPriceRecalculationResponse,
  // [saveQuantity],(state, action) => initialPriceRecalculationResponse,
  // [selectMultipleSelectionOption],(state, action) => initialPriceRecalculationResponse,
});
